import _mapValues from "lodash/mapValues";
import { getS3AssetPath } from "shared/lib/helpers";

const getImageAssetPath = (imageName: string) =>
  getS3AssetPath(`platform/shared-ui/${imageName}`);

export const BACKGROUND_SHAPES = _mapValues(
  {
    FIGURE_1: "gradient-blobs/gc_cloud_blur_1.svg",
    FIGURE_2: "gradient-blobs/gc_cloud_blur_2.svg",
    FIGURE_3: "gradient-blobs/gc_cloud_blur_3.svg",
    FIGURE_4: "gradient-blobs/gc_cloud_blur_4.svg",
    FIGURE_5: "gradient-blobs/gc_cloud_blur_5.svg",
    FIGURE_6: "gradient-blobs/gc_cloud_blur_6.svg",
    FIGURE_7: "gradient-blobs/gc_cloud_blur_7.svg",
  } as const,
  getImageAssetPath
);
